import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { stripRichText, syncListItemFontSizesInHtml } from '../utils/rich-text.validators';

/**
 * Prepares opportunity description/requirements for [innerHTML].
 * Bypasses Angular's style stripping so CKEditor font-size spans render.
 * Also copies font-size onto <li> so bullets/numbers scale with text.
 */
@Pipe({
  name: 'richText'
})
export class RichTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (value == null || value === '') {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const str = String(value);
    if (/<[a-z][\s\S]*>/i.test(str)) {
      return this.sanitizer.bypassSecurityTrustHtml(syncListItemFontSizesInHtml(str));
    }

    const escaped = str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\n/g, '<br>');

    return this.sanitizer.bypassSecurityTrustHtml(escaped);
  }
}

@Pipe({
  name: 'hasRichText'
})
export class HasRichTextPipe implements PipeTransform {
  transform(value: string | null | undefined): boolean {
    return stripRichText(value).length > 0;
  }
}
